const getBaseCdnUrl = (): string => {
  let CDN_BASE_URL = 'https://dlcdn.certus.com/global/js';
  const NODE_ENV = process.env.NODE_ENV?.toLowerCase();

  if (NODE_ENV === 'staging') {
    CDN_BASE_URL = CDN_BASE_URL.replace('dlcdn', 'mlcdn');
  }
  if (NODE_ENV === 'production') {
    CDN_BASE_URL = CDN_BASE_URL.replace('dlcdn', 'cdn');
  }
  return CDN_BASE_URL;
};

export default getBaseCdnUrl;
